module.exports = __webpack_public_path__ + "static/member-3-7cef42878641378e076596c67a7f433b.jpg";